<app-role-access [action]="'disable'" [permission]="'brigade.edit'" [placement]="'bottom-left'">
  <button
    data-role-element
    [ngbPopover]="userActionsPopContent"
    class="cur-pointer"
    placement="bottom-left"
    triggers="manual"
    #p2="ngbPopover"
    (click)="toggleWithBrigadeActionsContext(p2)"
    id="{{ 'appOpenRenameBrigadeActionPopover' + brigade.id }}"
  >
    <app-icon [color]="'red-gray-dark'" [size]="'14'" [glyph]="'dots'"></app-icon>
  </button>
</app-role-access>

<ng-template #userActionsPopContent>
  <div class="grid grid--gap-8">
    <div class="grid grid--gap-8 cur-pointer" (click)="onOpenRenameBrigadeDialog()" id="{{ 'appRenameBrigadeAction' + brigade.id }}">
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [color]="'red-gray-dark'" [size]="'14'" [glyph]="'edit'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <span class="link link--dotted-blue-dark">Переименовать</span>
      </div>
    </div>
  </div>
</ng-template>
